/*
Logic shared by all review steps, ALL props are listed here for clarity that
they are all passed to every review step
*/
export default {
  props: {
    step: {
      type: Object,
      required: true,
    },
    allSteps: {
      type: Object,
      required: true,
    },
    asset: {
      type: Object,
      required: true,
      validator(value) {
        const hasName = value['Name'] !== undefined;
        const hasUpdateId = value['OwnershipUpdateId'] !== undefined;
        return hasName && hasUpdateId;
      },
    },
    attributes: {
      type: Array,
      default() {
        return [];
      },
    },
    accessLevels: {
      type: Array,
      default() {
        return [];
      },
    },
    accessTooltips: {
      type: Object,
      default() {
        return {};
      },
    },
    accessList: {
      type: Array,
      default() {
        return [];
      },
    },
    assetType: {
      type: Object,
      default() {
        return {};
      },
    },
    customQuestions: {
      type: Array,
      default: () => [],
      validator(questions) {
        for (let q of questions) {
          if (q.Type === undefined || q.Options === undefined) return false;
        }
        return true;
      },
    },
    finalCustomQuestions: {
      type: Array,
      default() {
        return [];
      },
    },
    functionList: {
      type: Array,
      default() {
        return [];
      },
    },
    dependencies: {
      type: Array,
      default() {
        return [];
      },
    },
    userId: {
      type: String,
    },
  },
  computed: {
    configureSteps() {
      return this.$store.state.campaignDetails.configureReviewSteps;
    },
    readOnlyAccessReview() {
      return this.configureSteps.ReadOnlyAccessReview;
    },
  },
};
